<template>
  <div
    class="h-100 d-flex flex-column"
    style="overflow: hidden"
  >
    <div>
      <div class="d-flex justify-content-between align-items-center">
        <div class="page-header">
          <h1>
            {{ $t('shop.addSubscriptions') }}
          </h1>
        </div>
        <div>
          <button
            type="button"
            aria-label="Close"
            class="close"
            @click="cancel"
          >
            ×
          </button>
        </div>
      </div>

      <hr class="mt-1">
      <div v-show="!summary">
        <div class="d-flex justify-content-end mb-4">
          <div class="mr-4">
            <ReportCheckbox
              v-model="ignoreLimit"
              :text="$t('shop.ignoreLimit')"
            />
          </div>
          <div class="text-right">
            <button
              class="btn btn-primary btn-lg next-btn mr-1"
              @click="summary = true"
            >
              {{ $t('general.next') }}
              <i class="fas fa-arrow-right px-2" />
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-7">
            <OrderPayersList
              subscriptions-only
              :catalog-id="catalogId"
              :selected.sync="payers"
              :product-ids="selectedProducts"
              :selected-listings.sync="selectedListings"
              :selected-days="[]"
              :style="{
                overflowY: 'auto',
              }"
              @offer="offer = $event"
            />
          </div>
          <div class="col-5">
            <ProductList
              subscriptions
              :catalog-id="catalogId"
              :selected.sync="selectedProducts"
              :selected-listings.sync="selectedListings"
            />
          </div>
        </div>
      </div>
      <template v-if="summary">
        <div class="d-flex justify-content-between">
          <div
            style="width: 200px"
            class="text-left"
          >
            <button
              class="btn btn-secondary btn-lg next-btn mr-1"
              @click="summary = false"
            >
              {{ $t('general.back') }}
              <i class="fas fa-arrow-left px-2" />
            </button>
          </div>
          <div
            style="width: 200px"
            class="text-right"
          >
            <button
              class="btn btn-primary btn-lg next-btn mr-1"
              :disabled="pending"
              @click="save"
            >
              {{ $t('general.save') }}
              <i class="fas fa-check px-2" />
            </button>
          </div>
        </div>
        <hr>
        <OrderSingleSummary
          :payers="payers"
          :offer="offer"
          @orders="orders = $event"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ReportCheckbox from '@/components/reports/ReportCheckbox';
import OrderPayersList from './OrderPayersList';
import OrderSingleSummary from './OrderSingleSummary';
import ProductList from './ProductList';

export default {
  props: {
    catalogId: String,
  },
  data: () => ({
    payers: [],
    selectedProducts: [],
    selectedListings: [],
    summary: false,
    offer: [],
    orders: [],
    ignoreLimit: true,
    pending: false,
  }),
  components: {
    ReportCheckbox,
    ProductList,
    OrderPayersList,
    OrderSingleSummary,
  },
  computed: {
    ...mapGetters('shop', ['catalogDetails']),
  },
  methods: {
    ...mapActions('shop', ['getProducts', 'getCatalogListings', 'getShopCatalog', 'addSubscriptions']),
    save() {
      this.pending = true;

      this.addSubscriptions({
        params: {
          query: {
            catalogId: this.catalogId,
            ignoreLimit: this.ignoreLimit,
          },
        },
        data: {
          items: this.orders.map((x) => ({
            listingId: x.listingId,
            payerId: x.payerId,
          })),
        },
      })
        .then(() => {
          this.$router.back();
        })
        .finally(() => {
          this.pending = false;
        });
    },
    cancel() {
      this.$router.back();
    },
    request() {
      if (!this.listings || this.listings.length === 0) {
        this.getCatalogListings({
          params: {
            catalogId: this.catalogId,
          },
        });
      }
      if (!this.products || this.products.length === 0) {
        this.getProducts({
          params: {
            catalogId: this.catalogId,
          },
        });
      }

      if (!this.catalogDetails) {
        this.getShopCatalog({
          params: {
            catalogId: this.catalogId,
          },
        });
      }
    },
  },
  created() {
    this.request();
    this.$emit('page', 'form');
  },
};
</script>

<style lang="scss" scoped>
  .close {
    font-size: 40px;
  }
</style>
